/**------------- Info Card constants -------------**/

/*  General  */
export const INFO_CARD_CLASS_NAME = "info-card";
export const INFO_CARD_FLEX_CLASS_NAME = "info-card-flex";

/*  Icon  */
export const INFO_CARD_ICON_CLASS_NAME = "info-card-icon";
export const INFO_CARD_ICON_ALT = "info-card-with-icon";
